export default {
  category_name: 'Comprar tarjeta regalo',
};
